import { render, staticRenderFns } from "./AreaWarning.vue?vue&type=template&id=5415704e&scoped=true&"
import script from "./AreaWarning.vue?vue&type=script&lang=js&"
export * from "./AreaWarning.vue?vue&type=script&lang=js&"
import style0 from "./AreaWarning.vue?vue&type=style&index=0&id=5415704e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5415704e",
  null
  
)

export default component.exports